// Prüft vor dem Laden der Seite den Verwaltungs-Endpunkt und entscheidet,
// ob die Seite geladen werden darf. Vollständig self-contained (keine App-Styles nötig),
// da die App bei "Gesperrt"/"Wartung" gar nicht erst gemountet wird.

const ENDPOINT = "https://manage.frickenstein-cloud.de/api/lookup?id=";

const FONT =
  "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif";

function el(tag, css, text) {
  const e = document.createElement(tag);
  if (css) e.style.cssText = css;
  if (text != null) e.textContent = text;
  return e;
}

function showFullPageNotice(opts) {
  document.title = opts.title;
  document.body.innerHTML = "";
  document.body.style.cssText =
    "margin:0;min-height:100vh;display:flex;align-items:center;justify-content:center;" +
    `font-family:${FONT};background:#0f172a;color:#e2e8f0;padding:24px;box-sizing:border-box;`;

  const card = el(
    "div",
    "max-width:520px;width:100%;text-align:center;background:#1e293b;border:1px solid #334155;" +
      "border-radius:16px;padding:48px 32px;box-shadow:0 10px 40px rgba(0,0,0,.4);"
  );
  card.appendChild(
    el("div", "font-size:56px;line-height:1;margin-bottom:16px;", opts.icon)
  );
  card.appendChild(
    el(
      "h1",
      "margin:0 0 12px;font-size:24px;font-weight:700;color:#f8fafc;",
      opts.title
    )
  );
  card.appendChild(
    el("p", "margin:0;font-size:16px;line-height:1.6;color:#cbd5e1;", opts.text)
  );
  if (opts.message) {
    card.appendChild(
      el(
        "p",
        "margin:24px 0 0;padding:16px;background:#0f172a;border:1px solid #334155;border-radius:10px;" +
          "font-size:15px;line-height:1.6;color:#e2e8f0;white-space:pre-wrap;",
        opts.message
      )
    );
  }
  document.body.appendChild(card);
}

function showBanner(message) {
  const banner = el(
    "div",
    "position:relative;z-index:99999;width:100%;box-sizing:border-box;padding:12px 20px;" +
      `background:#2563eb;color:#fff;text-align:center;font-size:15px;line-height:1.5;font-family:${FONT};` +
      "white-space:pre-wrap;",
    message
  );
  document.body.insertBefore(banner, document.body.firstChild);
}

/**
 * Ruft den Endpunkt auf und entscheidet über die Anzeige.
 * @returns {Promise<{allowed: boolean}>} allowed=true wenn die App gemountet werden darf.
 */
export async function guardSite(id) {
  let data;
  try {
    // Antwortet der Endpunkt nicht innerhalb von 3 Sekunden, wird abgebrochen.
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);
    try {
      const res = await fetch(ENDPOINT + encodeURIComponent(id), {
        cache: "no-store",
        signal: controller.signal,
      });
      data = await res.json();
    } finally {
      clearTimeout(timeout);
    }
  } catch {
    // Fail-open: Ist der Endpunkt nicht erreichbar oder zu langsam (>3s),
    // wird so getan, als wäre der State "Aktiviert" mit leerer Message.
    return { allowed: true };
  }

  const state = data && data.state;
  const message = data && data.message;

  if (state === "Gesperrt") {
    showFullPageNotice({
      icon: "🔒",
      title: "Seite gesperrt",
      text: "Diese Seite ist derzeit nicht verfügbar.",
    });
    return { allowed: false };
  }

  if (state === "Fehler") {
    // Bei "Fehler" wird die Seite (und damit deren API) nicht geladen.
    showFullPageNotice({
      icon: "⚠️",
      title: "Fehler",
      text: "Es ist ein Fehler aufgetreten.",
    });
    return { allowed: false };
  }

  if (state === "Wartung") {
    showFullPageNotice({
      icon: "🛠️",
      title: "Wartungsarbeiten",
      text: "Diese Seite wird gerade gewartet. Bitte versuchen Sie es später erneut.",
      message,
    });
    return { allowed: false };
  }

  // "Aktiviert" (oder unbekannter Zustand -> fail-open): Seite laden, ggf. Banner anzeigen.
  if (message) showBanner(message);
  return { allowed: true };
}
